import React, { useState, useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { translate } = useLanguage();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: "smooth",
      });
      closeMobileMenu();
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setMobileMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const menuItems = ["home", "services", "products", "team", "contact"];

  return (
    <header>
      <div className="nav-container">
        <div className="header-container">
          {/* Logo di Kiri */}
          <div className="logo">
            <div className="logo-icon">S</div>
            <div className="logo-text">SAKAKA</div>
          </div>

          {/* Tombol "Hubungi Kami" di Tengah (Mobile) 
          <div className="mobile-cta-button">
            <button
              className="cta-button"
              onClick={() => scrollToSection("contact")}
            >
              {translate("contact-us")}
            </button>
          </div>*/}

          {/* Icon Menu di Kanan (Mobile) dengan language switcher */}
          <div className="mobile-menu-wrapper">
            <LanguageSwitcher mobile={true} />
            <div
              className="mobile-menu"
              onClick={toggleMobileMenu}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && toggleMobileMenu()}
            >
              <i
                className={`fas ${mobileMenuOpen ? "fa-times" : "fa-bars"}`}
              ></i>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className={mobileMenuOpen ? "active" : ""}>
            <ul>
              {menuItems.map((item) => (
                <li key={item}>
                  <button
                    onClick={() => scrollToSection(item)}
                    className="nav-button"
                    style={{
                      background: "none",
                      border: "none",
                      color: "var(--dark-gray)",
                      fontWeight: 500,
                      cursor: "pointer",
                      fontSize: "1rem",
                      fontFamily: "Poppins, sans-serif",
                      padding: mobileMenuOpen ? "15px 20px" : "5px 10px",
                      width: mobileMenuOpen ? "100%" : "auto",
                      textAlign: "left",
                      position: "relative",
                      transition: "color 0.3s",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {translate(item)}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          {/* Desktop CTA Button dengan language switcher*/}
          <div className="desktop-cta-button">
            <LanguageSwitcher />
            {/* <button
              className="cta-button"
              onClick={() => scrollToSection("contact")}
            >
              {translate("contact-us")}
            </button> */}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
